var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C38.8075 0 50 11.1925 50 25C50 38.8075 38.8075 50 25 50C11.1925 50 0 38.8075 0 25C0 11.1925 11.1925 0 25 0ZM35.7925 17.02C35.5203 16.7479 35.1573 16.5858 34.773 16.5648C34.3887 16.5438 34.0102 16.6654 33.71 16.9062L33.5825 17.02L20.9375 29.665L16.4175 25.145C16.1349 24.8623 15.7548 24.6987 15.3553 24.6878C14.9558 24.6768 14.5673 24.8193 14.2697 25.0861C13.972 25.3528 13.7879 25.7234 13.7552 26.1217C13.7225 26.5201 13.8436 26.9158 14.0938 27.2275L14.2075 27.355L19.8325 32.98C20.1047 33.2521 20.4677 33.4142 20.852 33.4352C21.2363 33.4562 21.6148 33.3346 21.915 33.0938L22.0425 32.98L35.7925 19.23C35.9376 19.0849 36.0528 18.9126 36.1313 18.723C36.2099 18.5334 36.2503 18.3302 36.2503 18.125C36.2503 17.9198 36.2099 17.7166 36.1313 17.527C36.0528 17.3374 35.9376 17.1651 35.7925 17.02Z",
    fill: "#078950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f3cf44d6.svg";
export { ForwardRef as ReactComponent };